import type { ListUndeliveredSmsResponse, ResendSmsResponse } from '@jq4race/shared';

import { request } from './client.js';

/**
 * resendSms — POST /supervisor/sms/resend
 *
 * Supervisor triggers a manual SMS resend for a given ticket.
 * The backend reuses the same signed link already stored (NFR-03).
 * Records an audit event (SC-10).
 *
 * Guard: JwtAuthGuard + supervisor-or-above role.
 */
export async function resendSms(ticketId: string): Promise<ResendSmsResponse> {
  return request<ResendSmsResponse>('/supervisor/sms/resend', {
    method: 'POST',
    body: { ticketId },
  });
}

/**
 * listUndeliveredSms — GET /supervisor/sms/undelivered
 *
 * Returns all SMS messages with status=failed for the authenticated
 * supervisor's organization. Used to populate the "SMS not delivered"
 * alert feed in admin and PWA Supervisor views (FR-04, SC-08).
 *
 * Guard: JwtAuthGuard + supervisor-or-above role.
 */
export async function listUndeliveredSms(): Promise<ListUndeliveredSmsResponse> {
  return request<ListUndeliveredSmsResponse>('/supervisor/sms/undelivered', {
    method: 'GET',
  });
}
